import { NgModule } from '@angular/core';

import { BadgeComponent } from './badge.component';

@NgModule({
  imports: [],
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
export { BadgeComponent } from './badge.component';
